<template>
  <v-dialog :value="isShow" :width="912" @click:outside="$emit('close-integration-modal')">
    <div class="settings-integrations__modal-close" @click="$emit('close-integration-modal')">&times;</div>

    <div v-if="currentIntegration" class="settings-integrations__modal">
      <div class="settings-integrations__modal-info">
        <div :class="currentIntegration.code" class="settings-integrations__list-item-top">
          <div v-if="currentIntegration.logo" class="settings-integrations__list-item-logo">
            <img :src="currentIntegration.logo" alt="" />
          </div>
        </div>

        <div class="settings-integrations__modal-info-name">
          <div class="settings-integrations__list-item-description-head">{{ title }}</div>

          <div class="settings-integrations__list-item-description-sub">{{ descriptionShort }}</div>
        </div>
      </div>

      <div class="settings-integrations__modal-desc">
        <div class="settings-integrations__modal-desc-title">
          {{
            currentIntegration.installed
              ? $tr('integrations.installed-integration')
              : $tr('integrations.installing-integration')
          }}
        </div>

        <div class="settings-integrations__modal-slider">
          <img
            v-if="currentIntegration.code === 'headhunter'"
            src="https://vcv-files.s3.eu-west-1.amazonaws.com/hh_pic.png"
            alt=""
          />
          <img
            v-if="currentIntegration.code === 'hackerrank'"
            src="https://vcv-files.s3.eu-west-1.amazonaws.com/hr_pic.png"
            alt=""
          />
        </div>

        <div class="settings-integrations__modal-desc-text">{{ description }}</div>

        <div class="settings-integrations__modal-install">
          <div v-if="!currentIntegration.installed" class="settings-integrations__modal-install-text">
            {{ $tr('integrations.agreement', { integrationName: title }) }}
          </div>

          <div class="settings-integrations__modal-install-button">
            <vbutton
              :text="
                currentIntegration.installed ? $tr('integrations.disable-integration') : $tr('integrations.install')
              "
              :loading="isIntegrationInstalling"
              size="big"
              @click="$emit('make-action')"
            />
          </div>
        </div>

        <template v-if="currentIntegration.installed && !!currentIntegration.code">
          <component :is="integrationAddon" />
        </template>
      </div>
    </div>
  </v-dialog>
</template>

<script>
const IntegrationAddonDefault = () =>
  import('@/routes_new/inner/settings/integrations/modal_addons/VcvSettingsIntegrationsModalDefault');
const IntegrationAddonHeadhunter = () =>
  import('@/routes_new/inner/settings/integrations/modal_addons/VcvSettingsIntegrationsModalHeadhunter');
const IntegrationAddonHrm = () =>
  import('@/routes_new/inner/settings/integrations/modal_addons/VcvSettingsIntegrationsModalHrm');
const IntegrationAddonHackerrank = () =>
  import('@/routes_new/inner/settings/integrations/modal_addons/VcvSettingsIntegrationsModalHackerrank');
const IntegrationAddonAssessfirst = () =>
  import('@/routes_new/inner/settings/integrations/modal_addons/VcvSettingsIntegrationsModalAssessfirst');

export default {
  components: {
    IntegrationAddonDefault,
    IntegrationAddonHeadhunter,
    IntegrationAddonHrm,
    IntegrationAddonHackerrank,
    IntegrationAddonAssessfirst
  },

  props: {
    isShow: {
      type: Boolean,
      default: false
    },

    currentIntegration: {
      type: Object,
      default: () => {}
    },

    title: {
      type: String,
      default: ''
    },

    description: {
      type: String,
      default: ''
    },

    descriptionShort: {
      type: String,
      default: ''
    },

    isIntegrationInstalling: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    integrationAddon() {
      if (this.currentIntegration.code) {
        return `integration-addon-${this.currentIntegration.code}`;
      }

      return 'integration-addon-default';
    }
  }
};
</script>

<style lang="scss" scoped>
.settings-integrations {
  &__modal {
    display: flex;
    background: #fff;
  }

  &__modal-info {
    width: 288px;
  }

  &__modal-info-name {
    padding: 16px;
    background: #fbfcfc;
  }

  &__modal-desc {
    padding: 24px;
    width: 100%;
  }

  &__modal-desc-title {
    font-size: 20px;
    font-weight: bold;
    line-height: 28px;
    color: #233346;
    margin-bottom: 25px;
  }

  &__modal-slider {
    margin-bottom: 24px;
    padding: 0 30px;

    img {
      width: 100%;
    }
  }

  &__modal-desc-text {
    font-size: 15px;
    line-height: 24px;
    color: #233346;
    margin-bottom: 80px;
  }

  &__modal-install {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  &__modal-install-text {
    font-size: 12px;
    line-height: 16px;
    text-align: right;
    color: #9faab6;
  }

  &__modal-install-button {
    margin-left: 10px;
  }

  &__modal-close {
    position: absolute;
    top: 23px;
    right: 26px;
    color: #9faab6;
    font-size: 30px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: color 0.3s;

    &:hover {
      color: darken(#9faab6, 15%);
      transition: color 0.3s;
    }
  }
}

::v-deep .v-dialog {
  position: relative;
}
</style>
